module.exports = __webpack_public_path__ + "static/es6-9794413ebf625127798f1b389c59e73e.png";